import { render, staticRenderFns } from "./FlyerShortInfoPopup.vue?vue&type=template&id=2f21e778&"
import script from "./FlyerShortInfoPopup.vue?vue&type=script&lang=js&"
export * from "./FlyerShortInfoPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports